import React from 'react'

type RemoveIconProps = {
  size?: number
}

export const RemoveIcon = ({ size = 11 }: RemoveIconProps) => (
  <svg
    fill='none'
    height={size}
    viewBox='0 0 11 11'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <line
      stroke='currentColor'
      strokeWidth='1.5'
      x1='11'
      x2='0'
      y1='5.5166'
      y2='5.5166'
    />
  </svg>
)
